<template>
  <div class="">
    <table border="1" class="rate-table">
      <tr>
        <th :colspan="PQCkeyList.length + 2">{{ props.year }} 年不合格汇总</th>
      </tr>
      <!-- 工序 -->
      <tr>
        <th></th>
        <th v-for="(item, index) in PQCkeyList" :key="index">
          <template v-if="item !== '合计'">
            {{ getProcessName(item) }}
          </template>

          <template v-else>
            {{ item }}
          </template>
        </th>
      </tr>

      <!-- 不合格数量 -->
      <template v-for="(item, key) in unQualified" :key="key">
        <tr>
          <th>{{ key }}</th>

          <template v-for="(count, index) in item" :key="index">
            <td :class="[ count ? 'error' : '' ]">{{ count === 0 ? "" : count }}</td>
          </template>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import { defineComponent, inject, watch, reactive } from "vue";
import { getProcessName } from "@/views/productDaily/serve/option";

export default defineComponent({
  props: {
    unQualifiedData: Object,
    year: String,
  },
  setup(props, context) {
    //
    const PQCkeyList = inject("PQCkeyList", []);
    // 不合格汇总
    const unQualified = reactive({
      物料导致: [],
      人为导致: [],
      半成品: [],
      软件导致: [],
      半成品: [],
      其他: [],
    });
    // 重置合格率汇总表格
    const setDataEmpty = () => {
      Object.keys(unQualified).forEach((key) => {
        unQualified[key].length = 0;
      });

      PQCkeyList.forEach(() => {
        Object.keys(unQualified).forEach((key) => {
          unQualified[key].push(0);
        });
      });
    };

    const setData = (data) => {
      if (Object.prototype.toString.call(data) !== "[object Object]") return;
      if (Object.keys(data).length === 0) return;
      Object.keys(data).forEach((key) => {
        const unQualifiedData = data[key];

        const pqcIndex = PQCkeyList.findIndex((f) => f === key);

        if (pqcIndex === -1) return;

        Object.keys(unQualifiedData).forEach((unQualifiedKey) => {
          let total = 0;
          Object.keys(unQualifiedData[unQualifiedKey]).forEach((month) => {
            total += unQualifiedData[unQualifiedKey][month].anomalyNumber;
          });
          unQualified[unQualifiedKey][unQualified[unQualifiedKey].length - 1] +=
            total;
          unQualified[unQualifiedKey][pqcIndex] = total;
        });
      });
    };

    watch(
      () => props.unQualifiedData,
      (val) => {
        setDataEmpty();
        setData(val);
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      getProcessName,
      PQCkeyList,
      unQualified,
    };
  },
});
</script>

<style lang="less" scoped>
.error {
  color: red;
}
.rate-table > tr > th {
  width: 120px;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  text-align: center;
}

.rate-table > tr > :nth-child(odd) {
  background: #e0e0e0;
}
</style>
